import type { SvgIconProps } from '@lokalise/ui/icons/SvgIcon';
import SvgIcon from '@lokalise/ui/icons/SvgIcon';
import { Rect } from '@lokalise/ui/icons/styles';
import type { Color } from '@lokalise/ui/icons/styles';

interface CheckboxIconProps extends SvgIconProps {
    secondaryColor?: Color;
}

const CheckboxEmpty = ({ secondaryColor = 'background.primary', ...props }: CheckboxIconProps) => (
    <SvgIcon {...props}>
        <Rect x="3" y="3" width="14" height="14" rx="2" stroke={props.color} fill={secondaryColor} />
    </SvgIcon>
);

export default CheckboxEmpty;
